<template>
	<div class="main-report tbl-list create-report agenda_info_area agenda_under_line">
		<h4>
			<span class="icon icon-up" v-b-toggle="'agenda_info_div'" aria-expanded="true" role="button"
				id="agenda_info_div-target"></span>アジェンダ・議事録
		</h4>

		<b-collapse id="agenda_info_div" visible>


			<div class="collapse show content-box dept-theme" id="agenda_info">
				<div class="agenda-main-box" style="padding-left: initial;">
					<div class="main-theme-request">
						<div class="theme_head_title">
							<i class="bi bi-circle-fill mr-1"></i>全体テーマ
						</div>
						<textarea-autosize class="form-control minutes-mode-readonly mt-2" placeholder="会議共通テーマを入力" v-bind:disabled=true :value=this.pre_theme></textarea-autosize>
					</div>


					<div class="mt-3">
						<table class="table" id="agenda_table">
							<thead class="thead-light">
								<tr>
									<th class="th-num" style="width:3%;">No.</th>
									<th class="th-time" style="width:8%;">時間</th>
									<th class="th-min" style="width:80px;">発表<BR />(分)</th>
									<th class="th-min" style="width:80px;">質疑応答<BR />(分)</th>
									<th class="th-sub">内容</th>
									<th class="th-dept" style="width:18%;">部門</th>
									<th class="th-presenter" style="width:12%;">発表者</th>
									<th class="th-report text-center" style="width:60px;">報告書</th>
									<th class="th-rest text-center" style="width:60px;">休憩</th>
									<th class="th-control" style="width:5%;"><span class="icon icon-up"
											data-toggle="collapse-all" aria-expanded="false" role="button"
											@click="doCollapse"></span></th>
								</tr>
							</thead>
							<tbody>

								<template v-for="agenda in ListCheckExist(agenda_detail)" :key="agenda.AGENDA_DETAIL_ID">
									<tr :id="agenda.AGENDA_DETAIL_ID" :agenda_detail_id="agenda.AGENDA_DETAIL_ID"
										class="agenda_row agenda_detail_row"
										v-bind:class='{ agenda_row_rest: (agenda.REST_CLASS == true) }'>
										<td class="td-num">
											<div class="sub-num">{{ agenda.NUM }}</div>
										</td>
										<td nowrap class="td-time">{{ agenda.TIME_FROMTO }}</td>
										<td class="td-min">
											<div class="presen-time">
												<input type="number" min="0" name="" id="pre_time"
													class="minutes-mode-readonly pretime form-control agendatime p-0 pl-3"
													v-model="agenda.PRESENTATION_TIME" v-bind:disabled=true>
											</div>
										</td>
										<td class="td-qa">
											<div class="qa-time">
												<input type="number" min="0" name="" id="qa_time"
													class="minutes-mode-readonly qatime form-control agendatime p-0 pl-3"
													v-model="agenda.QA_TIME" v-bind:disabled=true>
											</div>
										</td>
										<td class="td-sub td-contents"
											:style="`padding-left: ${agenda.AGENDA_INDENT}px ; padding-right: 0px;`"
											:lsize="agenda.AGENDA_INDENT">
											<div>
												<i class="bi bi-caret-left-fill cursor-pointer"
													style="visibility:hidden;"></i>
												<input type="text" id="naiyou" placeholder="内容を入力"
													class="minutes-mode-readonly naiyou form-control" autocomplete="off"
													name="" v-model="agenda.CONTENTS" v-bind:disabled=true>
												<i class="bi bi-caret-right-fill cursor-pointer"
													style="visibility:hidden;"></i>
											</div>
										</td>
										<td class="td-dept">
											<span class="select-wrap" style="width:100%;">
												<select name="dept_code"
													class="form-control dept_code_detail editable-select minutes-mode-readonly"
													modallabel="部門" v-model="agenda.DEPT_NAME" v-bind:disabled=true>
													<option>{{ agenda.DEPT_NAME }}</option>
												</select>
											</span>
										</td>
										<td class="td-presenter">
											<span class="select-wrap" style="width:100%;">
												<select name="user_id"
													class="user-select form-control presenter_detail editable-select minutes-mode-readonly"
													modallabel="主催者" v-model="agenda.PRESENTER_NAME" v-bind:disabled=true>
													<option>{{ agenda.PRESENTER_NAME }}</option>
												</select>
											</span>
										</td>
										<template v-if="agenda.REPORT_CLASS">
											<td class="td-report">
												<div class="report_detail">
													<input type="checkbox" name="" id="report_detail"
														class="minutes-mode-readonly form-control report-mark checkdis"
														style="transform:scale(0.5);" checked
														v-bind:disabled=true>
												</div>
											</td>
										</template>
										<template v-else>
											<td class="td-report">
												<div class="report_detail">
													<input type="checkbox" name="" id="report_detail"
														class="minutes-mode-readonly form-control report-mark checkdis"
														style="transform:scale(0.5);" 
														v-bind:disabled=true>
												</div>
											</td>
										</template>
										<template v-if="agenda.REST_CLASS">
											<td class="td-rest">
												<div class="rest_fg">
													<input type="checkbox" name="" id="rest_fg"
														class="minutes-mode-readonly form-control icon-rest checkdis"
														style="transform:scale(0.5);" checked
														v-bind:disabled=true>
												</div>
											</td>
										</template>
										<template v-else>
											<td class="td-rest">
												<div class="rest_fg">
													<input type="checkbox" name="" id="rest_fg"
														class="minutes-mode-readonly form-control icon-rest checkdis"
														style="transform:scale(0.5);" 
														v-bind:disabled=true>
												</div>
											</td>
										</template>
										<td class="td-control">
											<div>
												<span class="icon icon-up additional_target current-scroll"
													v-b-toggle="[`collapse-${agenda.AGENDA_DETAIL_ID}`]"
													:id="`collapse-${agenda.AGENDA_DETAIL_ID}-target`"
													:target="`collapse-${agenda.AGENDA_DETAIL_ID}`"></span>
											</div>
										</td>
									</tr>
									<template v-if="!agenda.REST_CLASS">
										<tr class="minute_row" :agenda_detail_id="agenda.AGENDA_DETAIL_ID">
											<td colspan="12" class="collapse-td p-0">
												<b-collapse :id="`collapse-${agenda.AGENDA_DETAIL_ID}`" class="mt-2"
													visible>
													<div class="">

														<div class="dept-theme-request agenda_detail_block">
															<div class="theme_head_title">
																<i class="bi bi-circle-fill mr-1"></i>個別テーマ
															</div>
															<textarea-autosize id="sub-theme-request"
																class="sub-theme-request form-control minutes-mode-readonly mt-2" placeholder="個別テーマを入力"
																v-model="agenda.AGENDA_THEMA"
																v-bind:disabled=true></textarea-autosize>
														</div>
														<div class="block_border"></div>
														<div class="agenda_detail_block">
															<div class="theme_head_title">
																<i class="bi bi-circle-fill mr-1"></i>発表議事録
															</div>
															<div class="announcement_minute_box mt-2">
																<div class="base_minutes" style="">
																	<table class="announcement_table" style="width: 100%;">
																		<thead>
																			<tr>
																				<th class="" style="width:2%;"></th>
																				<th style="width: 13%;">発言者</th>
																				<th style="width: 72%;">発言内容</th>
																				<th style="width: 13%;">タグ</th>
																				<th style="width: 0%; "></th>
																			</tr>
																		</thead>
																		<tbody class="">

																			<template
																				v-for="minutes in minutestlisthapyo(agenda.AGENDA_DETAIL_ID)"  :key="minutes.id">
																				<template v-if="minutes.border">
																					<tr style="" class="">
																						<td class="table-move-area"
																							style="width: 30px;">
																							<div>
																								<i
																									class="fas fa-arrows-alt handle"></i>
																							</div>
																						</td>
																						<td class="table-theme-area"
																							colspan="4"
																							:id="`theme_${minutes.id}`"
																							style="width: 1485px;">
																							<span class="minutestheme"
																								:theme=minutes.theme>{{
																									minutes.theme }}</span>
																						</td>
																					</tr>
																				</template>

																				<tr class="minutes_detail_row"
																					style="">
																					<td class="table-move-area">
																						<div>
																							<i
																								class="fas fa-arrows-alt handle"></i>
																						</div>
																					</td>
																					<td class="table-speaker-area">
																						<div class="minutes_speaker_block">
																							<template v-if=minutes.speaker>
																								<span
																									class="minutes_speaker_span tagblock"
																									:speaker=minutes.speaker>
																									<i
																										class="bi bi-person-circle2 mr-1">
																										<span
																											class="innericon_span">{{
																												minutes.speakerName
																											}}</span>
																									</i>
																									<span
																										class="Tag_Del"></span>
																								</span>
																							</template>
																						</div>
																					</td>
																					<td class="minutes_manager_area" v-bind:class='{ focusNow: (minutes.focusNow)}' :focusUser="minutes.focusNowUser" >
																						<img class="mr-2 write-icon cursor-pointer"
																							src="~@/assets/img/pen.png"
																							width="15" height="15" alt="">
																						<textarea-autosize
																							judge_minutes="hapyo"
																							class="minutes_manager mt-0 mr-0 mb-0 pt-0 pl-0 pr-0 pb-0"
																							:lsize="minutes.minutes_indent"
																							v-bind:style="{ width: 'calc(100% - ' + minutes.minutes_indent + 'px)', 'margin-left': minutes.minutes_indent + 'px', 'minHeight':'30px' }"
																							:agenda_detail_id="agenda.AGENDA_DETAIL_ID"
																							:id="minutes.id"
																							v-model="minutes.minutes_value"
																							@focusin.native="getTempMinutes($event);"
																							@focusout.native="confirm_minutes_manager_hapyo($event);"
																							@keydown.native="minutes_manager_event_keydown($event);"></textarea-autosize>
																						<ul class="list-group list-group-horizontal minute_action_list"
																							style="display: none;">
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-speaker"
																								title="発言者(Ctrl + ＠)"
																								target="speaker-area"
																								tabindex="0"><i
																									class="bi bi-person-circle2 bi-person-circle3 "></i>
																							</li>


																							<template v-if=minutes.border>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-border minutes-active-color"
																									title="テーマ"
																									target="border-area"
																									tabindex="0"><i
																										class="bi bi-flag-fill bi-flag-fill2 "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-border"
																									title="テーマ"
																									target="border-area"
																									tabindex="0"><i
																										class="bi bi-flag-fill bi-flag-fill2 "></i>
																								</li>
																							</template>


																							<template v-if=minutes.decision>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-decision minutes-active-color"
																									title="決定"
																									iconarea="additional-info-decision"
																									target="decision-area"
																									tabindex="0"
																									v-if=minutes.decision><i
																										class="bi bi-pin-angle-fill "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-decision"
																									title="決定"
																									iconarea="additional-info-decision"
																									target="decision-area"
																									tabindex="0"><i
																										class="bi bi-pin-angle-fill "></i>
																								</li>
																							</template>

																							<template
																								v-if=minutes.important>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-important minutes-active-color"
																									title="重要"
																									iconarea="additional-info-important"
																									target="important-area"
																									tabindex="0"
																									v-if=minutes.important>
																									<i
																										class="bi bi-exclamation-circle-fill "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-important"
																									title="重要"
																									iconarea="additional-info-important"
																									target="important-area"
																									tabindex="0"><i
																										class="bi bi-exclamation-circle-fill "></i>
																								</li>
																							</template>

																							<template v-if=minutes.taskid>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-task minutes-active-color"
																									title="タスク(Ctrl + ：)"
																									iconarea="additional-info-task"
																									target="task-area"
																									tabindex="0">
																									<i
																										class="innericon bi bi-pin-task-fill "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-task"
																									title="タスク(Ctrl + ：)"
																									iconarea="additional-info-task"
																									target="task-area"
																									tabindex="0">
																									<i
																										class="innericon bi bi-pin-task-fill "></i>
																								</li>
																							</template>
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-tag"
																								title="タグ(Ctrl + ・)"
																								iconarea="additional-info-tag"
																								target="tag-area"
																								tabindex="0"><i
																									class="innericon bi bi-tags-fill2 bi-tags-fill3 "></i>
																							</li>
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-addrow"
																								title="行追加" target=""
																								tabindex="0">
																								<i
																									class="bi bi-arrow-return-left "></i>
																							</li>
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-delete"
																								title="行削除" target=""
																								tabindex="0"
																								@mousedown="deleteMinutesRow">
																								<i
																									class="bi bi-trash "></i>
																							</li>
																						</ul>
																						<ul class="list-group list-group-horizontal person_tag_history_list mt-2 mb-3  person_tag_history_list_wrapper"
																							style="display: none;">
																							<ul
																								class="list-group list-group-horizontal history_list">
																								<li class="list-group-item">
																									履歴</li>
																							</ul>
																							<ul
																								class="list-group list-group-horizontal person_history_list">
																							</ul>
																							<ul
																								class="list-group list-group-horizontal tag_history_list">
																							</ul>
																						</ul>
																						<input type="text" name="dummytext"
																							class="form-control dummytext"
																							style="width:1px; height:1px; visibility:hidden;">
																					</td>
																					<td class="table-tag-area">
																						<div class="minutes_tag_block">
																							<span
																								class="additional-info-decision tagblock"
																								v-if=minutes.decision>
																								<i class="mr-1 bi bi-pin-angle-fill"
																									:target=minutes.id><span
																										class="Tag_Del"></span></i>
																							</span>
																							<span
																								class="additional-info-decision"
																								v-else></span>
																							<span
																								class="additional-info-important tagblock"
																								v-if=minutes.important>
																								<i class="mr-1 bi bi-exclamation-circle-fill"
																									:target=minutes.id><span
																										class="Tag_Del"></span></i>
																							</span>
																							<span
																								class="additional-info-important"
																								v-else></span>

																							<span
																								class="additional-info-task cursor-pointer tagblock"
																								v-if=minutes.taskid>
																								<i class="bi bi-pin-task-fill"
																									:target=minutes.id
																									:taskid=minutes.taskid></i>
																								<span
																									class="Tag_Del"></span>
																							</span>
																							<span
																								class="additional-info-task cursor-pointer"
																								v-else></span>

																							<span
																								class="additional-info-tag cursor-pointer">
																								<template
																									v-for="intag in ListCheckExist(minutes.tag)" :key="intag.id">
																									<span
																										class="tagblock tag_block_width"
																										v-if="intag && intag.id">
																										<i class="mr-1 bi bi-tags-fill2 tag_width"
																											:target="intag.target"
																											:tagid="intag.id"
																											:id="intag.id"
																											:title="intag.title">
																											<span
																												class="ml-1 pr-1">{{
																													intag.title
																												}}</span>
																										</i>
																										<span
																											class="Tag_Del"></span>
																									</span>
																								</template>
																							</span>
																						</div>
																					</td>
																					<td class="dummy-tag-area"
																						style="display:none;">
																						<li class="list-group-item tag-area-left pl-1 pr-1"
																							tag-area
																							style="min-width:20%;max-width:20%;">
																							<div class="decision-area"
																								datatype="decision-area"
																								classsetting="mr-1 bi bi-pin-angle-fill">
																							</div>
																							<div class="important-area"
																								datatype="important-area"
																								classsetting="mr-1 bi bi-exclamation-circle-fill">
																							</div>
																							<div class="task-area"
																								datatype="task-area">
																								<template
																									v-if=minutes.taskid>
																									<p class="mr-2 text-truncate minutes-task"
																										:insertflag=minutes.insertFlag
																										:taskorg=minutes.taskorg
																										:taskorgname=minutes.taskorgname
																										:taskorgflag=minutes.taskorgflag
																										:taskperson=minutes.taskperson
																										:taskpersonname=minutes.taskpersonname
																										:taskpersonflag=minutes.taskpersonflag
																										:taskgroup=minutes.taskgroup
																										:taskid=minutes.taskId
																										:id=minutes.taskId
																										:target=minutes.id>
																										<i
																											class="innericon mr-1 bi bi-pin-task-fill"></i>
																										<span>
																											<span
																												class="innericon_span"></span>
																											<span
																												class="task_date">
																												<template
																													v-if=minutes.taskDate>{{
																														minutes.taskDate
																													}}</template>
																											</span>
																											<span
																												class="task_date_noval"></span>
																										</span>
																										<span
																											class="disp-title-task"
																											:nameflag=minutes.nameFlag
																											:saveflag=minutes.saveFlag>
																											<template
																												v-if=minutes.nameFlag>{{
																													minutes.taskName
																												}}</template>
																											<template
																												v-else>{{
																													minutes.minutes_value
																												}}</template>
																										</span>
																									</p>
																								</template>
																							</div>
																							<div class="tag-area"
																								datatype="tag-area"></div>
																						</li>
																					</td>
																				</tr>

																			</template>



																		</tbody>
																	</table>
																</div>
															</div>
														</div>
														<div class="block_border"></div>
														<div class="agenda_detail_block">
															<div class="theme_head_title">
																<i class="bi bi-circle-fill mr-1"></i>会話議事録
															</div>
															<div class="minute_box mt-2">
																<div class="base_minutes">
																	<table class="minutes_table" style="width: 100%;">
																		<thead>
																			<tr>
																				<th class="" style="width:2%;"></th>
																				<th style="width: 13%;">発言者</th>
																				<th style="width: 72%;">発言内容</th>
																				<th style="width: 13%;">タグ</th>
																				<th style="width: 0%; "></th>
																			</tr>
																		</thead>
																		<tbody class="">

																			<template
																				v-for="minutes in minutestlistkaiwa(agenda.AGENDA_DETAIL_ID)" :key="minutes.id">

																				<template v-if="minutes.border">
																					<tr style="" class="">
																						<td class="table-move-area"
																							style="width: 30px;">
																							<div>
																								<i
																									class="fas fa-arrows-alt handle"></i>
																							</div>
																						</td>
																						<td class="table-theme-area"
																							colspan="4"
																							:id="`theme_${minutes.id}`"
																							style="width: 1485px;">
																							<span class="minutestheme"
																								:theme=minutes.theme>{{
																									minutes.theme }}</span>
																						</td>
																					</tr>
																				</template>

																				<tr class="minutes_detail_row"
																					style="">
																					<td class="table-move-area">
																						<div>
																							<i
																								class="fas fa-arrows-alt handle"></i>
																						</div>
																					</td>
																					<td class="table-speaker-area">
																						<div class="minutes_speaker_block">
																							<template v-if=minutes.speaker>
																								<span
																									class="minutes_speaker_span tagblock"
																									:speaker=minutes.speaker>
																									<i
																										class="bi bi-person-circle2 mr-1">
																										<span
																											class="innericon_span">{{
																												minutes.speakerName
																											}}</span>
																									</i>
																									<span
																										class="Tag_Del"></span>
																								</span>
																							</template>
																						</div>
																					</td>
																					<td class="minutes_manager_area"  v-bind:class='{ focusNow: (minutes.focusNow)}' :focusUser="minutes.focusNowUser" >
																						<img class="mr-2 write-icon cursor-pointer"
																							src="~@/assets/img/pen.png"
																							width="15" height="15" alt="">
																						<textarea-autosize
																							judge_minutes="kaiwa"
																							class="minutes_manager mt-0 mr-0 mb-0 pt-0 pl-0 pr-0 pb-0"
																							:lsize="minutes.minutes_indent"
																							v-bind:style="{ width: 'calc(100% - ' + minutes.minutes_indent + 'px)', 'margin-left': minutes.minutes_indent + 'px' }"
																							:agenda_detail_id="agenda.AGENDA_DETAIL_ID"
																							:id="minutes.id"
																							v-model="minutes.minutes_value"
																							@focusin.native="getTempMinutes($event);"
																							@focusout.native="confirm_minutes_manager_kaiwa($event);"
																							@keydown.native="minutes_manager_event_keydown($event); "></textarea-autosize>
																						<ul class="list-group list-group-horizontal minute_action_list"
																							style="display: none;">
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-speaker"
																								title="発言者(Ctrl + ＠)"
																								target="speaker-area"
																								tabindex="0">
																								<i
																									class="bi bi-person-circle2 bi-person-circle3 "></i>
																							</li>

																							<template v-if=minutes.border>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-border minutes-active-color"
																									title="テーマ"
																									target="border-area"
																									tabindex="0">
																									<i
																										class="bi bi-flag-fill bi-flag-fill2 "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-border"
																									title="テーマ"
																									target="border-area"
																									tabindex="0">
																									<i
																										class="bi bi-flag-fill bi-flag-fill2 "></i>
																								</li>
																							</template>

																							<template v-if=minutes.decision>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-decision minutes-active-color"
																									title="決定"
																									iconarea="additional-info-decision"
																									target="decision-area"
																									tabindex="0"
																									v-if=minutes.decision><i
																										class="bi bi-pin-angle-fill "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-decision"
																									title="決定"
																									iconarea="additional-info-decision"
																									target="decision-area"
																									tabindex="0"><i
																										class="bi bi-pin-angle-fill "></i>
																								</li>
																							</template>

																							<template
																								v-if=minutes.important>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-important minutes-active-color"
																									title="重要"
																									iconarea="additional-info-important"
																									target="important-area"
																									tabindex="0"
																									v-if=minutes.important>
																									<i
																										class="bi bi-exclamation-circle-fill "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-important"
																									title="重要"
																									iconarea="additional-info-important"
																									target="important-area"
																									tabindex="0"><i
																										class="bi bi-exclamation-circle-fill "></i>
																								</li>
																							</template>

																							<template v-if=minutes.taskid>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-task minutes-active-color"
																									title="タスク(Ctrl + ：)"
																									iconarea="additional-info-task"
																									target="task-area"
																									tabindex="0">
																									<i
																										class="innericon bi bi-pin-task-fill "></i>
																								</li>
																							</template>
																							<template v-else>
																								<li class="list-group-item cursor-pointer minutes-canfocus minutes-task"
																									title="タスク(Ctrl + ：)"
																									iconarea="additional-info-task"
																									target="task-area"
																									tabindex="0">
																									<i
																										class="innericon bi bi-pin-task-fill "></i>
																								</li>
																							</template>
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-tag"
																								title="タグ(Ctrl + ・)"
																								iconarea="additional-info-tag"
																								target="tag-area"
																								tabindex="0"><i
																									class="innericon bi bi-tags-fill2 bi-tags-fill3 "></i>
																							</li>
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-addrow"
																								title="行追加" target=""
																								tabindex="0">
																								<i
																									class="bi bi-arrow-return-left "></i>
																							</li>
																							<li class="list-group-item cursor-pointer minutes-canfocus minutes-delete"
																								title="行削除" target=""
																								tabindex="0"
																								@mousedown="deleteMinutesRow">
																								<i
																									class="bi bi-trash "></i>
																							</li>
																						</ul>
																						<ul class="list-group list-group-horizontal person_tag_history_list mt-2 mb-3  person_tag_history_list_wrapper"
																							style="display: none;">
																							<ul
																								class="list-group list-group-horizontal history_list">
																								<li class="list-group-item">
																									履歴</li>
																							</ul>
																							<ul
																								class="list-group list-group-horizontal person_history_list">
																							</ul>
																							<ul
																								class="list-group list-group-horizontal tag_history_list">
																							</ul>
																						</ul>
																						<input type="text" name="dummytext"
																							class="form-control dummytext"
																							style="width:1px; height:1px; visibility:hidden;">
																					</td>
																					<td class="table-tag-area">
																						<div class="minutes_tag_block">
																							<span
																								class="additional-info-decision tagblock"
																								v-if=minutes.decision>
																								<i class="mr-1 bi bi-pin-angle-fill"
																									:target=minutes.id><span
																										class="Tag_Del"></span></i>
																							</span>
																							<span
																								class="additional-info-decision"
																								v-else></span>
																							<span
																								class="additional-info-important tagblock"
																								v-if=minutes.important>
																								<i class="mr-1 bi bi-exclamation-circle-fill"
																									:target=minutes.id><span
																										class="Tag_Del"></span></i>
																							</span>
																							<span
																								class="additional-info-important"
																								v-else></span>
																							<span
																								class="additional-info-task cursor-pointer tagblock"
																								v-if=minutes.taskid>
																								<i class="bi bi-pin-task-fill"
																									:target=minutes.id
																									:taskid=minutes.taskid></i>
																								<span
																									class="Tag_Del"></span>
																							</span>
																							<span
																								class="additional-info-task cursor-pointer"
																								v-else></span>

																							<span
																								class="additional-info-tag cursor-pointer">
																								<template
																									v-for="intag in ListCheckExist(minutes.tag)" :key="intag.id">
																									<span
																										class="tagblock tag_block_width"
																										v-if="intag && intag.id">
																										<i class="mr-1 bi bi-tags-fill2 tag_width"
																											:target="intag.target"
																											:tagid="intag.id"
																											:id="intag.id"
																											:title="intag.title">
																											<span
																												class="ml-1 pr-1">{{
																													intag.title
																												}}</span>
																										</i>
																										<span
																											class="Tag_Del"></span>
																									</span>
																								</template>
																							</span>
																						</div>
																					</td>
																					<td class="dummy-tag-area"
																						style="display:none;">
																						<li class="list-group-item tag-area-left pl-1 pr-1"
																							tag-area
																							style="min-width:20%;max-width:20%;">
																							<div class="decision-area"
																								datatype="decision-area"
																								classsetting="mr-1 bi bi-pin-angle-fill">
																							</div>
																							<div class="important-area"
																								datatype="important-area"
																								classsetting="mr-1 bi bi-exclamation-circle-fill">
																							</div>
																							<div class="task-area"
																								datatype="task-area">
																								<template
																									v-if=minutes.taskid>
																									<p class="mr-2 text-truncate minutes-task"
																										:insertflag=minutes.insertFlag
																										:taskorg=minutes.taskorg
																										:taskorgname=minutes.taskorgname
																										:taskorgflag=minutes.taskorgflag
																										:taskperson=minutes.taskperson
																										:taskpersonname=minutes.taskpersonname
																										:taskpersonflag=minutes.taskpersonflag
																										:taskgroup=minutes.taskgroup
																										:taskid=minutes.taskId
																										:id=minutes.taskId
																										:target=minutes.id>
																										<i
																											class="innericon mr-1 bi bi-pin-task-fill"></i>
																										<span>
																											<span
																												class="innericon_span"></span>
																											<span
																												class="task_date">
																												<template
																													v-if=minutes.taskDate>{{
																														minutes.taskDate
																													}}</template>
																											</span>
																											<span
																												class="task_date_noval"></span>
																										</span>
																										<span
																											class="disp-title-task"
																											:nameflag=minutes.nameFlag
																											:saveflag=minutes.saveFlag>
																											<template
																												v-if=minutes.nameFlag>{{
																													minutes.taskName
																												}}</template>
																											<template
																												v-else>{{
																													minutes.minutes_value
																												}}</template>
																										</span>
																									</p>
																								</template>
																							</div>
																							<div class="tag-area"
																								datatype="tag-area"></div>
																						</li>
																					</td>
																				</tr>

																			</template>
																		</tbody>
																	</table>
																</div>
															</div>
														</div>
													</div>
												</b-collapse>

											</td>
										</tr>
									</template>

								</template>

							</tbody>
						</table>
					</div>

				</div>
			</div>

		</b-collapse>
        <div class="sk-fading-circle hide" style="display:none;">
			<div class="sk-circle1 sk-circle"></div>
			<div class="sk-circle2 sk-circle"></div>
			<div class="sk-circle3 sk-circle"></div>
			<div class="sk-circle4 sk-circle"></div>
			<div class="sk-circle5 sk-circle"></div>
			<div class="sk-circle6 sk-circle"></div>
			<div class="sk-circle7 sk-circle"></div>
			<div class="sk-circle8 sk-circle"></div>
			<div class="sk-circle9 sk-circle"></div>
			<div class="sk-circle10 sk-circle"></div>
			<div class="sk-circle11 sk-circle"></div>
			<div class="sk-circle12 sk-circle"></div>
		</div>
	</div>

	<SpeakerModal ref="SpeakerModal" @domergespeaker="doMergeMinutesSpeaker" />
	<ThemeModal @domergetheme="doMergeMinutesTheme" />
	<TaskModal @createrighttask-emit="emitCreateRightTask" @domergetask="doMergeMinutesTask" :csfr="csfr" :sendTask="sendTask" />
	<TagModal ref="TagModal" @createrighttag-emit="emitCreateRightTag" @domergetag="doMergeMinutesTag" :sendTag="sendTag"/>
	<CheckBeforeUpdate ref="CheckBeforeUpdate" @dosave-emit = "emitDoSave"/>
</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";
import config from "@/config";
import 'jquery-ui-bundle';

export default {
	props: {
		sync: Object,
		userid: String,
		username: String,
		agenda_detail: Object,
		inithapyo: Object,
		initkaiwa: Object,
		csfr: String,
		pre_theme: Object,
		sendTask: Object,
		sendTag: Object,
		hapyoTemp: Object,
		kaiwaTemp: Object,
		first_minutes_state: String,
	},
	data: () => ({
		minutes_info_hapyo: {},
		minutes_info_kaiwa: {},
		initializehapyo: true,
		initializekaiwa: true,
		tempMessage: null,
		isGiijrokuUpdate : false,
		minutes_state : "0",
	}),
	watch: {
		minutes_info_hapyo: function (newval, oldval) {
			
			let _self = this;

			this.$nextTick(() => {
				_self.setSortable($("#agenda_table"));
			});

			if (!_self.initializehapyo) {
				return;
			}
			
			_self.initializehapyo = false;

			if( _self.inithapyo != undefined && !_self.isEmpty(_self.inithapyo) && _self.minutes_info_hapyo != undefined && _self.isEmpty(_self.minutes_info_hapyo) ) {
				_self.minutes_info_hapyo = _self.inithapyo;
			}

			this.$nextTick(() => {
				$.each($(".agenda_detail_row"), function (i, elem) {
					const agenda_detail_id = $(elem).attr("id");

					if (!(agenda_detail_id in _self.minutes_info_hapyo) || _self.minutes_info_hapyo[agenda_detail_id].length == 0) {
						_self.addminutesinfohapyo(nanoid(32), agenda_detail_id, "")
					}
				});

				if (_self.agenda_detail != undefined && _self.agenda_detail.length > 0) {
					var now = new Date();
					var timeTo = new Date(now.getFullYear() + "/" + (now.getMonth() + 1) + "/" + now.getDate() + " " + _self.agenda_detail[0]["TIME_FROM"]);
					var num = 0;
					var branchNum = 0;
					$.each($(".agenda_detail_row"), function (i, elem) {
						// No.を採番
						if (_self.agenda_detail[i]["AGENDA_INDENT"] == 0) {
							num = num + 1;
							branchNum = 0;
							_self.agenda_detail[i]["NUM"] = num;
						} else {
							branchNum = branchNum + 1;
							_self.agenda_detail[i]["NUM"] = num + "-" + branchNum;
						}

						// 発表時間を作成
						var prtime = _self.agenda_detail[i]["PRESENTATION_TIME"]
						var qatime = _self.agenda_detail[i]["QA_TIME"]
						var prqatime = Number(prtime) + Number(qatime);

						var timeFrom = new Date(timeTo);
						var tempH = 0;
						var tempMI = timeFrom.getMinutes() + Number(prqatime);
						if (tempMI < 60) {
							timeTo = new Date(now.getFullYear() + "/" + (now.getMonth() + 1) + "/" + now.getDate() + " " + timeFrom.getHours() + ":" + (timeFrom.getMinutes() + Number(prqatime)));
						} else {
							tempH = Math.floor(tempMI / 60)
							tempMI = tempMI - (tempH * 60);
							timeTo = new Date(now.getFullYear() + "/" + (now.getMonth() + 1) + "/" + now.getDate() + " " + (timeFrom.getHours() + Number(tempH)) + ":" + tempMI);
						}
						
						const timeFromTo = _self.formatDateAtMinute(timeFrom, true, false) + " - " + _self.formatDateAtMinute(timeTo, true, false);
						_self.agenda_detail[i]["TIME_FROMTO"] = timeFromTo;

						// チェックボックス
						if (_self.agenda_detail[i]["REPORT_CLASS"] == "1") {
							_self.agenda_detail[i]["REPORT_CLASS"] = true;
						} else {
							_self.agenda_detail[i]["REPORT_CLASS"] = false;
						}
						if (_self.agenda_detail[i]["REST_CLASS"] == "1") {
							_self.agenda_detail[i]["REST_CLASS"] = true;
						} else {
							_self.agenda_detail[i]["REST_CLASS"] = false;
						}
					});

				}
				_self.setSortable($("#agenda_table"));

			});

		},
		minutes_info_kaiwa: function (newval, oldval) {
			let _self = this;


			this.$nextTick(() => {
				_self.setSortable($("#agenda_table"));
			});
			if (!_self.initializekaiwa) {
				return;
			}

			if( _self.initkaiwa != undefined && !_self.isEmpty(_self.initkaiwa) && _self.minutes_info_kaiwa != undefined && _self.isEmpty(_self.minutes_info_kaiwa)) {
			 	_self.minutes_info_kaiwa = _self.initkaiwa;
			}


			this.$nextTick(() => {
				$.each($(".agenda_detail_row"), function (i, elem) {

					const agenda_detail_id = $(elem).attr("id");

					if (!(agenda_detail_id in _self.minutes_info_kaiwa) || _self.minutes_info_kaiwa[agenda_detail_id].length == 0) {
						_self.addminutesinfokaiwa(nanoid(32), agenda_detail_id, "")
					}

				});
				_self.setSortable($("#agenda_table"));
			});

			_self.initializekaiwa = false;
		}
	},
	async created() {

		let _self = this;

		this.sync.observe((event) => {

			if (event.keysChanged.has("minutes_info_hapyo")) {
					
				var minutes_id = "";
				
				var values = _self.sync.get("minutes_info_hapyo");
				if (values != undefined) {
					var tempList = values;
					
					var $focus = $(':focus')
					var tempVal = "";
					
					_self.minutes_info_hapyo = tempList;
					_self.$emit('getHapyo', tempList);
				}
			}


			if (event.keysChanged.has("minutes_info_kaiwa")) {

				var values = _self.sync.get("minutes_info_kaiwa");
				if (values != undefined) {
					var tempList = values;
					
					var $focus = $(':focus')
					var tempVal = "";

					_self.minutes_info_kaiwa = tempList;
					_self.$emit('getKaiwa', tempList);
				}

			}

			if (event.keysChanged.has("isUpdate")) {
				_self.isGiijrokuUpdate = _self.sync.get("isUpdate");
			}

			if (event.keysChanged.has("minutes_state")) {
				_self.minutes_state = _self.sync.get("minutes_state");
			}

		});

	},


	methods: {

		async emitModal() {
			var _self = this;
			console.log(_self.first_minutes_state)
			console.log("www")
			// 議事録ステータスが完了の場合ポップアップ
			if (_self.minutes_state == "1") {
				$("#check-before-update-modal").modal();
			} else {
				await _self.sync.set("minutes_state", "1");	
				this.$emit('dosave-emit', true);
			}
		},
		emitDoSave(isSave) {
			this.$emit('dosave-emit', isSave);
		}
		,
		getGijirokuUpdate() {
			var _self = this;
			return _self.isGiijrokuUpdate;
		},

		initPage() {

			var _self = this;
			var $gijiroku = $("#gijiroku_henshu_user img");

			Promise.resolve().then(
				function(){
					return new Promise(async function (resolve, reject) {
						if($gijiroku.length == 1 && $gijiroku.attr("userid") == _self.userid) {

							var tempListHapyo = _self.hapyoTemp;
							_self.minutes_info_hapyo = tempListHapyo;
							_self.$emit('getHapyo', _self.minutes_info_hapyo);	

							var tempListKaiwa = _self.kaiwaTemp;
							_self.minutes_info_kaiwa = tempListKaiwa;
							_self.$emit('getKaiwa', _self.minutes_info_kaiwa);
							// kaiwaはfocusinがないので、ここでset
							await _self.sync.set("minutes_info_kaiwa");	

							resolve();

						} else {

							var valuesHapyo = await _self.sync.get("minutes_info_hapyo");
							var tempListHapyo = valuesHapyo || _self.hapyoTemp;
							_self.minutes_info_hapyo = tempListHapyo;
							_self.$emit('getHapyo', _self.minutes_info_hapyo);

							var valuesKaiwa = await _self.sync.get("minutes_info_kaiwa");
							var tempListKaiwa = valuesKaiwa || _self.kaiwaTemp;
							_self.minutes_info_kaiwa = tempListKaiwa;
							_self.$emit('getKaiwa', _self.minutes_info_kaiwa);

							resolve();

						}
					});
				}
			).then(
				function() {
				return new Promise(async function (resolve, reject) {
					_self.setSortable($("#agenda_table"));
					await _self.minutesFocus();
					resolve();
				});
				}
			)
		}

		,replaceNullData() {
			var _self = this;	
			
			var $onsei = $("#gijiroku_henshu_user img");
			if(!$onsei.length) {
				this.$nextTick(() => {
					this.sync.set("minutes_info_hapyo", {});
					this.sync.set("minutes_info_kaiwa", {});
				});
				
			} else {
				if($onsei.length == 1 && $onsei.attr("userid") == this.userid) {

				this.$nextTick(() => {
					this.sync.set("minutes_info_hapyo", {});
					this.sync.set("minutes_info_kaiwa", {});
				});
				}
			}

			
			// 過去フォーカスを外す
			var $focusElem = $(".focusNow")
			var delFocusindex = -1;
			for (let i = 0; i < $focusElem.length; i++) {
				let user = $focusElem.eq(i).attr("focususer");
				if (user == this.username) {
					delFocusindex = i;
					break;
				}
			}
			if (delFocusindex != -1) {
				var $target = $focusElem.eq(delFocusindex);
				var $textarea = $target.find(".minutes_manager");
				var agenda_detail_id_delFocus = $textarea.attr("agenda_detail_id");
				var minutes_id_delFocus = $textarea.attr("id");
				var delList = null;
				var target = "";
				if (_self.isJudgeHapyo($textarea)) {
					delList = _self.minutes_info_hapyo;
					target = "hapyo"
				} else {
					delList	= _self.minutes_info_kaiwa;
					target = "kaiwa";
				}
				_self.outFocus(delList, {objectid:minutes_id_delFocus, agenda_detail_id:agenda_detail_id_delFocus}, target);

			}
		},

		async minutesFocus() {
			var _self = this;
			var flag = false;
			$.each($("#agenda_table").find(".minute_row"), function(i, row) {
				if (flag) {
					return false;
				}
				if ($(row).is("[dummy-row]") || $(row).prev().attr("rest_class") == "1") {
					return;
				}
				$.each($(row).find(".announcement_minute_box .base_minutes"), function(i, box) {
					if ($(box).is("[dummy-row]")) {
						return;
					}
					$.each($(box).find(".announcement_table tbody tr") , function(i, minutes) {
						if ($(minutes).hasClass("copyrow")) {
							return;
						}

						setTimeout(function(){ 
							$(minutes).find("textarea").focus();
							_self.isGiijrokuUpdate = false;
							_self.minutes_state = _self.first_minutes_state;
						},50);
						flag = true;
						return false;
					});
				});
			});
		},

		ListCheckExist(elem) {
			if (elem) {
				return elem;
			}
		},
		minutestlisthapyo(agendaid) {

			if (this.minutes_info_hapyo[agendaid]) {
				this.minutes_info_hapyo[agendaid].splice();
				return this.minutes_info_hapyo[agendaid];

			}
		},

		minutestlistkaiwa(agendaid) {

			if (this.minutes_info_kaiwa[agendaid]) {
				this.minutes_info_kaiwa[agendaid].splice();
				return this.minutes_info_kaiwa[agendaid];
				
			}
		},

		confirm_minutes_manager_hapyo(e) {

			let $elem = $(e.target);
			if ($elem.length == 0) {
				$elem = $(e)
			}
			
			if ($elem.val() != this.tempMessage) {
				const diff = { objectid: $elem.attr("id"), agenda_detail_id: $elem.attr("agenda_detail_id"), minutes_value: $elem.val(), before_row_minuteid: "", minutes_class: "01", modify_flag: true, minutes_indent: $elem.attr("lsize") }
				this.doMergeMinutes(this.minutes_info_hapyo, diff, "hapyo", true);
			} else {
				this.outFocus(this.minutes_info_hapyo, {objectid: $elem.attr("id"), agenda_detail_id: $elem.attr("agenda_detail_id")}, "hapyo");
			}
		},
		
		confirm_minutes_manager_kaiwa(e) {

			let $elem = $(e.target);

			if ($elem.length == 0) {
				$elem = $(e)
			}

			if ($elem.val() != this.tempMessage) {
				const diff = { objectid: $elem.attr("id"), agenda_detail_id: $elem.attr("agenda_detail_id"), minutes_value: $elem.val(), before_row_minuteid: "", minutes_class: "02", modify_flag: true, minutes_indent: $elem.attr("lsize") }
				this.doMergeMinutes(this.minutes_info_kaiwa, diff, "kaiwa");
			} else {
				this.outFocus(this.minutes_info_kaiwa, {objectid: $elem.attr("id"), agenda_detail_id: $elem.attr("agenda_detail_id")}, "kaiwa");
			}
		},

		getTempMinutes(e) {


			let $elem = $(e.target);

			if ($elem.length == 0) {
				$elem = $(e)
			}
			this.tempMessage = $elem.val();

			this.setFocus($elem);
		},

		setFocus(elem) {

			var agenda_detail_id = elem.attr("agenda_detail_id");
			var minutes_id = elem.attr("id");
			var list = null;
			if (this.isJudgeHapyo(elem)) {
				list = this.minutes_info_hapyo;
			} else {
				list = this.minutes_info_kaiwa;
			}

			// 過去フォーカスを外す
			var $focusElem = $(".focusNow")
			var delFocusindex = -1;
			for (let i = 0; i < $focusElem.length; i++) {
				let user = $focusElem.eq(i).attr("focususer");
				if (user == this.username) {
					delFocusindex = i;
					break;
				}
			}
			if (delFocusindex != -1) {
				var $target = $focusElem.eq(delFocusindex);
				var $textarea = $target.find(".minutes_manager");
				var agenda_detail_id_delFocus = $textarea.attr("agenda_detail_id");
				var minutes_id_delFocus = $textarea.attr("id");
				var delList = null;
				var target = "";
				if (this.isJudgeHapyo($textarea)) {
					delList = this.minutes_info_hapyo;
					target = "hapyo"
				} else {
					delList	= this.minutes_info_kaiwa;
					target = "kaiwa";
				}
				this.outFocus(delList, {objectid:minutes_id_delFocus, agenda_detail_id:agenda_detail_id_delFocus}, target);

			}

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			if (index != -1) {
				var row = list[agenda_detail_id][index];
				row["focusNow"] = true;
				row["focusNowUser"] = this.username;
			}

			if (this.isJudgeHapyo(elem)) {
				this.sync.set("minutes_info_hapyo", list);
			} else {
				this.sync.set("minutes_info_kaiwa", list);
			}

		},

		unloadFocus() {

			var _self = this;
			// 過去フォーカスを外す
			var $focusElem = $(".focusNow")
			var delFocusindex = -1;
			for (let i = 0; i < $focusElem.length; i++) {
				let user = $focusElem.eq(i).attr("focususer");
				if (user == this.username) {
					delFocusindex = i;
					break;
				}
			}
			if (delFocusindex != -1) {
				var $target = $focusElem.eq(delFocusindex);
				var $textarea = $target.find(".minutes_manager");
				var agenda_detail_id_delFocus = $textarea.attr("agenda_detail_id");
				var minutes_id_delFocus = $textarea.attr("id");
				var delList = null;
				var target = "";
				if (_self.isJudgeHapyo($textarea)) {
					delList = _self.minutes_info_hapyo;
					target = "hapyo"
				} else {
					delList	= _self.minutes_info_kaiwa;
					target = "kaiwa";
				}
				_self.outFocus(delList, {objectid:minutes_id_delFocus, agenda_detail_id:agenda_detail_id_delFocus}, target);

			}
		},

		outFocus(list, diff, target){
			const objectid = diff.objectid;
			const agenda_detail_id = diff.agenda_detail_id;
			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === objectid)
			if (index != -1) {
				var row = list[agenda_detail_id][index];
				row["focusNow"] = false;
				row["focusNowUser"] = null;
			}
			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);

			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}
		},

		doMergeMinutes(list, diff, target, noupdateflag) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}

			const objectid = diff.objectid;
			const agenda_detail_id = diff.agenda_detail_id;
			const minutes_value = diff.minutes_value;
			const before_row_minuteid = diff.before_row_minuteid;
			const add_flag = diff.add_flag;
			const minutes_class = diff.minutes_class;
			const modify_flag = diff.modify_flag;
			const minutes_indent = diff.minutes_indent;

			let $focusElem = $(':focus');
			let focusindex = -1;
			let suffix = "";

				if ($focusElem.length && $focusElem.hasClass("minutes_manager")) {
					if (this.isJudgeHapyo($focusElem)) {
						suffix = 'hapyo';
					} else {
						suffix = 'kaiwa';
					}
					focusindex = $(".minutes_manager[judge_minutes='" + suffix + "']").index($focusElem);
				}
				
				if (list[agenda_detail_id] == undefined) {
					list[agenda_detail_id] = [];
					let addData = { agenda_detail_id: agenda_detail_id, id: objectid, minutes_value: minutes_value, minutes_class: minutes_class, minutes_indent: "0" };
					list[agenda_detail_id].push(addData);
				} else {

					if (before_row_minuteid != "") {


						let index = list[agenda_detail_id].findLastIndex(({ id }) => id === before_row_minuteid)
						let addData = { agenda_detail_id: agenda_detail_id, id: objectid, minutes_value: minutes_value, minutes_class: minutes_class, minutes_indent: minutes_indent };

						list[agenda_detail_id] = [
							...list[agenda_detail_id].slice(0, (index + 1)),
							...[addData],
							...list[agenda_detail_id].slice((index + 1))
						]

						if (focusindex != -1 && index <= focusindex) {

							this.$nextTick(() => {
								$(".minutes_manager[judge_minutes='" + suffix + "']").eq((focusindex + 1)).focus();
							});
						}

					} else {
						let index = list[agenda_detail_id].findLastIndex(({ id }) => id === objectid)
						if (index != -1) {
							var row = list[agenda_detail_id][index];

							row["agenda_detail_id"] = agenda_detail_id;
							row["id"] = objectid;
							row["minutes_value"] = minutes_value;
							row["minutes_class"] = minutes_class;
							row["minutes_indent"] = minutes_indent;
						} else {

							if (add_flag) {
								let addData = { agenda_detail_id: agenda_detail_id, id: objectid, minutes_value: minutes_value, minutes_class: minutes_class, minutes_indent: "", task: [], minutes_indent: minutes_indent };
								list[agenda_detail_id].push(addData);

								if (focusindex != -1 && index <= focusindex) {
									this.$nextTick(() => {
										$(".minutes_manager[judge_minutes='" + suffix + "']").eq((focusindex + 1)).focus();
									});
								}
							}
						}
					}
				}

				if(!noupdateflag) {
					if (target == "hapyo") {
						this.sync.set("minutes_info_hapyo", list);
					} else if (target == "kaiwa") {
						this.sync.set("minutes_info_kaiwa", list);
					}
				}

			this.outFocus(list, diff, target);

		},

		doDeleteMinutes(list, diff, target) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}

			const objectid = diff.objectid;
			const agenda_detail_id = diff.agenda_detail_id;
			const minutes_class = diff.minutes_class

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === objectid);
			list[agenda_detail_id].splice(index, 1
			);

			if (list[agenda_detail_id].length == 0) {
				let addData = { agenda_detail_id: agenda_detail_id, id: diff.new_objectid, minutes_value: "", minutes_class: minutes_class, task: [], minutes_indent: "0" };
				list[agenda_detail_id].push(addData);
			}

			setTimeout(function () {
				if ($(".minutes_manager[judge_minutes='" + target + "'][agenda_detail_id='" + agenda_detail_id + "']").eq(index).length) {
					$(".minutes_manager[judge_minutes='" + target + "'][agenda_detail_id='" + agenda_detail_id + "']").eq(index).focus();
				} else {
					$(".minutes_manager[judge_minutes='" + target + "'][agenda_detail_id='" + agenda_detail_id + "']").eq(index-1).focus();
				}
			}, 50);
		

			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}

		},

		addminutesinfohapyo(objectid, agenda_detail_id, minutes_value, before_row_minuteid = "", minutes_indent = "0") {
			const diff = { objectid: objectid, agenda_detail_id: agenda_detail_id, minutes_value: minutes_value, minutes_class: "01", before_row_minuteid: before_row_minuteid, add_flag: true, minutes_indent: minutes_indent }
			this.doMergeMinutes(this.minutes_info_hapyo, diff, "hapyo");

		},
		addminutesinfokaiwa(objectid, agenda_detail_id, minutes_value, before_row_minuteid = "", minutes_indent = "0") {
			const diff = { objectid: objectid, agenda_detail_id: agenda_detail_id, minutes_value: minutes_value, minutes_class: "02", before_row_minuteid: before_row_minuteid, add_flag: true, minutes_indent: minutes_indent }
			this.doMergeMinutes(this.minutes_info_kaiwa, diff, "kaiwa");

		},
		escapeSelectorString(val) {
			if (!isNaN(val)) {
				return val;
			} else {
				return val.replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, "\\$&");
			}
		},
		parseStrToBoolean(str) {
			// 文字列を判定
			return (str == 'true') ? true : false;
		},
		doCollapse(e) {

			const _self = this;
			const $collapse = $(e.target);
			const isIconDown = $collapse.hasClass("icon-down");
			const isIconUp = $collapse.hasClass("icon-up");
			const $target = $(".additional_target")

			$.each($target, function (i, elem) {
				const elemHasDown = $(elem).hasClass("icon-down")
				const elemHasUp = $(elem).hasClass("icon-up")
				const targetId = $(elem).attr("target");

				if (isIconDown && elemHasDown) {
					_self.$root.$emit('bv::toggle::collapse', targetId)
				}
				if (isIconUp && elemHasUp) {
					_self.$root.$emit('bv::toggle::collapse', targetId)
				}

			});

			this.$collapseAction($collapse, isIconDown);

		},

		isJudgeHapyo(elem) {

			const judge_minutes = $(elem).attr("judge_minutes");

			if (judge_minutes == "hapyo") {
				return true;
			}

			return false;

		},
		minutes_manager_event_keydown(e) {

			const elem = e.target;
			var _self = this;
			var useraAgent = window.navigator.userAgentData;
			var atSignCode = "";
			var colonCode = "";
			var slash = 191;
			if (useraAgent == null) {
				atSignCode = 64;
				colonCode = 58;
			} else {
				atSignCode = 192;
				colonCode = 186;
			}

			if (e.keyCode == 13) {
				if (e.altKey || e.shiftKey) {

					if (!this.isGiijrokuUpdate) {
						this.isGiijrokuUpdate = true;
						this.sync.set("isUpdate", this.isGiijrokuUpdate);
					}	
					var sentence = elem.value;
					var len = sentence.length;
					var pos = elem.selectionStart;
					var before = sentence.substr(0, pos);
					var word = "\r\n";
					var after = sentence.substr(pos, len);
					sentence = before + word + after;
					$(elem).val(sentence);
					elem.selectionStart = pos + 1;
					elem.selectionEnd = pos + 1;
					e.preventDefault();
					this.changeTextareaHeight(e, true);
				} else {

					if ($(elem).val().replace(/\s/g, "").length > 0) {
						
						if (!this.isGiijrokuUpdate) {
							this.isGiijrokuUpdate = true;
							this.sync.set("isUpdate", this.isGiijrokuUpdate);
						}	

						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();

						const nextMinutesManagerId = nanoid(32);
						const lsize = $(elem).attr("lsize");
						if (this.isJudgeHapyo(elem)) {
							this.confirm_minutes_manager_hapyo($(elem));
							this.addminutesinfohapyo(nextMinutesManagerId, $(elem).attr("agenda_detail_id"), "", $(elem).attr("id"), lsize)
						} else {
							this.confirm_minutes_manager_kaiwa($(elem));
							this.addminutesinfokaiwa(nextMinutesManagerId, $(elem).attr("agenda_detail_id"), "", $(elem).attr("id"), lsize)
						}

					} else {
						e.preventDefault();
					}
				}
			} else if (e.keyCode == 9) {
				if (e.shiftKey) {
					e.preventDefault();
					var $lsize = null;
					var $addleft = null;
					$lsize = $(elem).attr("lsize");
					$addleft = Number($lsize) - 40;
					if ($addleft <= 0) {
						$addleft = 0;
						$(this).find(".minutes_manager_ul").css("list-style", "square");
					}
					$(elem).css({ "width": "calc(100% - " + $addleft + "px)" });
					$(elem).attr("lsize", $addleft);
					$(elem).css({ "margin-left": $addleft + "px" });
					$(elem).find(".minutes_manager_ul_right").css({ "margin-left": $addleft + "px" });
					if ($lsize <= 0) {
						$(this).focus();
					}
				} else {
					e.preventDefault();
					if (Number($(elem).attr("lsize")) > 80) {
						return;
					}
					var $lsize = null;
					var $addleft = null;
					$lsize = $(elem).attr("lsize");
					$addleft = Number($lsize) + 40;
					$(elem).css({ "width": "calc(100% - " + $addleft + "px)" });
					$(elem).attr("lsize", $addleft);
					$(elem).css({ "margin-left": $addleft + "px" });
					$(elem).css("list-style", "circle");
					$(elem).css({ "margin-left": $addleft + "px" });
				}
				// インデント制御を同時編集機能に反映
				this.doMergeMinutesIndent(elem);
			} else if (e.keyCode == atSignCode && e.ctrlKey) {
				e.preventDefault();
				$("#minutes-speaker-modal").modal();
				return false;
			} else if (e.keyCode == slash && e.ctrlKey) {
				e.preventDefault();
				$("#minutes-tag-modal").modal();
			} else if (e.keyCode == colonCode && e.ctrlKey) {
				e.preventDefault();
				var $minutes_manager_area = $(elem).closest(".minutes_manager_area");
				$minutes_manager_area.find(".dummytext").focus();

				
				var $textarea = $minutes_manager_area.closest("tr").find(".minutes_manager");
				var taskId = "Task" + _self.getObjectID();
				var minutesId = $textarea.attr("id");
				var agenda_detail_id = $textarea.attr("agenda_detail_id");
				var target = $textarea.attr("judge_minutes");

				_self.doMergeMinutesTask(target, agenda_detail_id, minutesId, taskId, [], [], [], [], [], [], [], true, false, true, null, null);
				setTimeout(function () {
					$minutes_manager_area.find("textarea").focus();
				}, 50);
			}
		},
		formatDateAtMinute(time, flag, typeTimeFlg) {
			var timeobj;

			if (typeTimeFlg) {
				// 時刻のみの場合
				timeobj = new Date("1900/01/01 " + time);
			} else {
				// 日付型の場合
				timeobj = new Date(time);
			}

			if (time == null || isNaN(timeobj)) {
				return "";
			}
			if (flag) {
				return this.paddingHeadZero(timeobj.getHours()) + ":" + this.paddingHeadZero(timeobj.getMinutes());
			} else {
				return timeobj.getHours() + ":" + paddingHeadZero(timeobj.getMinutes());
			}
		},

		paddingHeadZero(num) {
			if (num < 10) {
				return "0" + num;
			}
			return num;
		},

		changeTextareaHeight(e, input_flag) {

			const textarea = e.target;

			var nowHeight = $(textarea).height();
			var scrollHeight = $(textarea).get(0).scrollHeight;

			if (input_flag) {

				var min_height = 26;
				$(textarea).height(min_height); //一旦最小サイズにする
				$(textarea).height($(textarea).get(0).scrollHeight);

			} else {

				if (nowHeight == scrollHeight) {
					return false;
				}

				var min_height = 26;
				$(textarea).height(min_height); //一旦最小サイズにする
				$(textarea).height($(textarea).get(0).scrollHeight);
			}
		},

		deleteMinutesRow(e) {

			if (!this.isLeftClick(e)) {
				return false;
			}

			const $elem = $(e.target).closest(".minutes_detail_row");
			const el = $elem.find(".minutes_manager");

			if (this.isJudgeHapyo(el)) {
				const diff = { objectid: $(el).attr("id"), agenda_detail_id: $(el).attr("agenda_detail_id"), minutes_value: $(el).val(), minutes_class: "01", before_row_minuteid: "", new_objectid: nanoid(32) }
				this.doDeleteMinutes(this.minutes_info_hapyo, diff, "hapyo");
			} else {
				const diff = { objectid: $(el).attr("id"), agenda_detail_id: $(el).attr("agenda_detail_id"), minutes_value: $(el).val(), minutes_class: "02", before_row_minuteid: "", new_objectid: nanoid(32) }
				this.doDeleteMinutes(this.minutes_info_kaiwa, diff, "kaiwa");
			}
		},

		eventStop(e) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
		},

		isLeftClick(e) {
			if (e.which != 1) {
				return false;
			}
			return true;
		},

		isEmpty(obj) {
			return !Object.keys(obj).length;
		},

		doClickUsually(elem) {

			const $target = $(elem);
			const $targetarea = $target.closest("tr").find(".tag-area-left").find('[datatype="' + this.escapeSelectorString($target.attr("target")) + '"]');
			const $textarea = $target.closest("tr").find(".minutes_manager");
			var minutes_id = $target.closest("tr").find(".minutes_manager").attr("id");
			var agenda_detail_id = $target.closest("tr").find(".minutes_manager").attr("agenda_detail_id");
			var target = "";
			var iconType = "";
			var isCheck = true;
			if ($target.hasClass("minutes-active-color")) {
				isCheck = false;
			}

			if ($target.hasClass("minutes-important")) {
				iconType = "important";
			} else {
				iconType = "decision";
			}
			if (this.isJudgeHapyo($textarea)) {
				target = 'hapyo';
			} else {
				target = 'kaiwa';
			}
			this.doMergeMinutesUsually(target, agenda_detail_id, minutes_id, isCheck, iconType);

		},

		doMergeMinutesUsually(target, agenda_detail_id, minutes_id, isCheck, iconType) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}

			var list = null;
			if (target == "hapyo") {
				list = this.minutes_info_hapyo;
			} else if (target == "kaiwa") {
				list = this.minutes_info_kaiwa;
			}

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			var row = list[agenda_detail_id][index];
			if (iconType == "important") {
				row["important"] = isCheck;
			} else if (iconType == "decision") {
				row["decision"] = isCheck;
			} else if (iconType == "speaker") {
				row["speaker"] = "";
				row["speakerName"] = "";
			}

			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}

		},

		doMergeMinutesSpeaker(target, agenda_detail_id, minutes_id, speakerId, speakerName) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}

			var list = null;
			if (target == "hapyo") {
				list = this.minutes_info_hapyo;
			} else if (target == "kaiwa") {
				list = this.minutes_info_kaiwa;
			}

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			var row = list[agenda_detail_id][index];
			row["speaker"] = speakerId;
			row["speakerName"] = speakerName;

			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}

		},

		doMergeMinutesTheme(target, agenda_detail_id, minutes_id, isBorderCheck, themeText) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}
			
			var list = null;
			if (target == "hapyo") {
				list = this.minutes_info_hapyo;
			} else if (target == "kaiwa") {
				list = this.minutes_info_kaiwa;
			}

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			var row = list[agenda_detail_id][index];
			row["border"] = isBorderCheck;
			row["theme"] = themeText;

			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}

		},

		doMergeMinutesTag(target, agenda_detail_id, minutes_id, tagId, tagName, deleteFg) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}

			var list = null;
			if (target == "hapyo") {
				list = this.minutes_info_hapyo;
			} else if (target == "kaiwa") {
				list = this.minutes_info_kaiwa;
			}

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			var row = list[agenda_detail_id][index];
			if (!row["tag"]) {
				row["tag"] = [];
			}

			let indexAdd = row["tag"].findLastIndex(({ id }) => id === tagId);
			if (!deleteFg) {
				if (indexAdd == -1) {
					row["tag"].push({ target: minutes_id, id: tagId, title: tagName });
				} else {
					row["tag"][indexAdd] = { target: minutes_id, id: tagId, title: tagName };
				}
			} else {
				let indexDel = row["tag"].findLastIndex(({ id }) => id === tagId);
				delete row["tag"][indexDel];
				row["tag"] = row["tag"].filter(Boolean);
			}

			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}

		},

		doMergeMinutesTask(target, agenda_detail_id, minutes_id, taskId, taskorg, taskorgname, taskorgflag, taskperson, taskpersonname, taskpersonflag, taskgroup, nameFg, saveFg, insertFg, taskName, dueDate) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}

			var list = null;
			if (target == "hapyo") {
				list = this.minutes_info_hapyo;
			} else if (target == "kaiwa") {
				list = this.minutes_info_kaiwa;
			}

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			var row = list[agenda_detail_id][index];
			row["taskid"] = taskId;
			row["taskorg"] = taskorg;
			row["taskorgname"] = taskorgname;
			row["taskorgflag"] = taskorgflag;
			row["taskperson"] = taskperson;
			row["taskpersonname"] = taskpersonname;
			row["taskpersonflag"] = taskpersonflag;
			row["taskgroup"] = taskgroup;
			row["nameFlag"] = nameFg;
			row["saveFlag"] = saveFg;
			row["insertFlag"] = insertFg;
			row["taskName"] = taskName;
			row["taskDate"] = dueDate;

			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}

		},

		doMergeMinutesIndent(elem) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}

			const agenda_detail_id = $(elem).attr("agenda_detail_id");
			const minutes_indent = $(elem).attr("lsize");
			const target = $(elem).attr("judge_minutes");
			const minutes_id = $(elem).attr("id");
			let list = null;

			if (target == "hapyo") {
				list = this.minutes_info_hapyo;
			} else if (target == "kaiwa") {
				list = this.minutes_info_kaiwa;
			}

			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			let row = list[agenda_detail_id][index];
			row["minutes_indent"] = minutes_indent;

			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo", list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa", list);
			}
		},

		doMergeMinutesSort(elem) {

			if (!this.isGiijrokuUpdate) {
				this.isGiijrokuUpdate = true;
				this.sync.set("isUpdate", this.isGiijrokuUpdate);
			}
			

			var $focus = $(':focus')

			if ($focus.length && $focus.hasClass("minutes_manager")) {
				var agenda_detail_id = $focus.attr("agenda_detail_id");
				var minutes_id = $focus.attr("id");
			}

			$(".minutes_manager_area[sortable-child-area]").removeAttr("sortable-child-area");
			
			// 発表議事録、会話議事録判断用
			let target = null;
			let minutes_manager = null;
			// ソート変更対象の行が議事録明細行の場合
			if(elem.find(".minutes_manager").length) {
				target = elem.find(".minutes_manager").attr("judge_minutes");
			// 対象の行がテーマの場合
			} else if(elem.find(".table-theme-area").length){
				const id = elem.find(".table-theme-area").attr("id").replace("theme_", "");
				minutes_manager = $("#" + id);
				target = minutes_manager.attr("judge_minutes");
			}
			
			let list = null;
			
			if (target == "hapyo") {
				list = this.minutes_info_hapyo;
			} else if (target == "kaiwa") {
				list = this.minutes_info_kaiwa;
			}
			
			// ソート変更対象の行が議事録明細行の場合
			if(elem.find(".minutes_manager").length) {
				list = this.sortMinutes(elem, list);
			// 対象の行がテーマの場合
			} else if(elem.find(".table-theme-area").length){
				list = this.sortTheme(elem, minutes_manager, list);
			}

			let nowIndex = -1;
			if ($focus.length && $focus.hasClass("minutes_manager")) {
				nowIndex = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			}
			
			
				
			if (target == "hapyo") {
				this.sync.set("minutes_info_hapyo",  list);
			} else if (target == "kaiwa") {
				this.sync.set("minutes_info_kaiwa",  list);
			}
			
			if (nowIndex != -1) {
				this.$nextTick(() => {
					$(".minutes_manager[judge_minutes='" + target + "']").eq(nowIndex).focus();
				});
			}
		},
			

		
		sortMinutes(elem, list) {
			const minutes_manager = elem.find(".minutes_manager");
			const agenda_detail_id = minutes_manager.attr("agenda_detail_id");
			const minutes_id = minutes_manager.attr("id");
			
			// 並び替え前のインデックス
			let index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			// 並び替え前データを退避
			const temp = list[agenda_detail_id][index];
	
			// 並び替え前データを削除
			list[agenda_detail_id].splice(index, 1);
	
			// 並び替え後の次の明細データ
			const next = elem.closest(".minutes_detail_row").next(".minutes_detail_row").find(".minutes_manager");
			const nextIndex = list[agenda_detail_id].findLastIndex(({ id }) => id === $(next).attr("id"));
			// 並び替え後の前の明細データ
			const prev = elem.closest(".minutes_detail_row").prev(".minutes_detail_row").find(".minutes_manager");
			const prevIndex = list[agenda_detail_id].findLastIndex(({ id }) => id === $(prev).attr("id"));
	
			// 元データを並び替え先に追加
			if (nextIndex != -1) {
				list[agenda_detail_id].splice(nextIndex, 0, temp);
			} else if (prevIndex != -1) {
				list[agenda_detail_id].splice(prevIndex + 1, 0, temp);
			} else {
				list[agenda_detail_id].splice(0, 0, temp);
			}
			
			// 並び替え先の行を取得
			const current_index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			const current_row = list[agenda_detail_id][current_index];
			
			const themerow = $("#theme_" + minutes_id).closest("tr");
			// 対象の議事録明細にテーマが設定されている場合
			if (themerow.length) {
				// テーマの次の行に議事録明細が存在しない場合、新規行を作成
				if (!themerow.next().hasClass("minutes_detail_row")) {
					const new_id = nanoid(32);
					// 1行前の議事録の下に作成
					const prev_id = themerow.prev().find(".minutes_manager").attr("id");
					if (this.isJudgeHapyo(minutes_manager)) {
						this.addminutesinfohapyo(new_id, agenda_detail_id, "", prev_id, "0");
					} else {
						this.addminutesinfokaiwa(new_id, agenda_detail_id, "", prev_id, "0");
					}
					// 1行前の議事録が存在しない場合、一番下に作成された新規行を一番上に入れ替え
					if(prev_id == undefined) {
						const add_list = list[agenda_detail_id].pop();
						list[agenda_detail_id].splice(0, 0, add_list);
					}
				}
				
				// テーマに紐づいていた議事録を1行下の議事録に付け替え
				current_row["border"] = false;
				const temp_theme = current_row["theme"];
				current_row["theme"] = null;
				
				let next_index = null;
				// テーマの次の行が議事録の場合
				if(themerow.next().find(".minutes_manager_area").length) {
					const next_minutes_manager_area = themerow.next().find(".minutes_manager_area");
					const next_id = next_minutes_manager_area.find(".minutes_manager").attr("id");
					next_index = list[agenda_detail_id].findLastIndex(({ id }) => id === next_id);
				} else {
					// テーマの次の行が議事録でない場合、前の行 + 1
					const prev_id = themerow.prev().find(".minutes_manager").attr("id");
					const prev_index = list[agenda_detail_id].findLastIndex(({ id }) => id === prev_id);
					next_index = prev_index + 1;
				}
				
				const next_row = list[agenda_detail_id][next_index];
				next_row["border"] = true;
				next_row["theme"] = temp_theme;
				
				// 1つ前の行が議事録明細行以外の場合、並び替え対象の行にIDを付け替え
				const prev_minutes = elem.closest(".minutes_detail_row").prev();
				if (prev_minutes.length && !prev_minutes.hasClass("minutes_detail_row")) {
					const prev_id = prev_minutes.find(".table-theme-area").attr("id").replace("theme_", "");
					const prev_index = list[agenda_detail_id].findLastIndex(({ id }) => id === prev_id);
					const prev_row = list[agenda_detail_id][prev_index];
					prev_row["border"] = false;
					const temp_theme = prev_row["theme"];
					prev_row["theme"] = null;
					
					current_row["border"] = true;
					current_row["theme"] = temp_theme;
					
				} else {

				}
			// 対象の議事録明細にテーマが設定されていない場合
			} else {
				// 1つ前の行が議事録明細行以外の場合、並び替え対象の行にIDを付け替え
				const prev_minutes = elem.closest(".minutes_detail_row").prev();
				if (prev_minutes.length && !prev_minutes.hasClass("minutes_detail_row")) {
					const prev_id = prev_minutes.find(".table-theme-area").attr("id").replace("theme_", "");
					const prev_index = list[agenda_detail_id].findLastIndex(({ id }) => id === prev_id);
					const prev_row = list[agenda_detail_id][prev_index];
					prev_row["border"] = false;
					const temp_theme = prev_row["theme"];
					prev_row["theme"] = null;
					
					current_row["border"] = true;
					current_row["theme"] = temp_theme;
					
				} 
			}
			return list;
		},
		
		sortTheme(elem, minutes_manager, list) {
			
			const agenda_detail_id = minutes_manager.attr("agenda_detail_id");
			const minutes_id = minutes_manager.attr("id");
			const new_id = nanoid(32);
			
			// 1つ前の行が議事録明細以外の場合、1つ前のテーマの下に議事録明細の新規行を追加
			if (elem.prev().length && !elem.prev().hasClass("minutes_detail_row")) {
				// 1行前の議事録の下に作成
				const prev_id = elem.prev().prev().find(".minutes_manager").attr("id");
				if (this.isJudgeHapyo(minutes_manager)) {
					this.addminutesinfohapyo(new_id, agenda_detail_id, "", prev_id, "0");
				} else {
					this.addminutesinfokaiwa(new_id, agenda_detail_id, "", prev_id, "0");
				}
				
				// 1行前の議事録が存在しない場合、一番下に作成された新規行を一番上に入れ替え
				if(prev_id == undefined) {
					const add_list = list[agenda_detail_id].pop();
					list[agenda_detail_id].splice(0, 0, add_list);
				}
				
				const next_id = elem.next().find(".minutes_manager").attr("id");
				const next_index = list[agenda_detail_id].findLastIndex(({ id }) => id === next_id);
				const next_row = list[agenda_detail_id][next_index];
				
				next_row["border"] = false;
				const temp_theme = next_row["theme"];
				next_row["theme"] = null;
				
				const after_row = list[agenda_detail_id][next_index - 1];
				after_row["border"] = true;
				after_row["theme"] = temp_theme;
				
			// 次の行が議事録以外の場合
			} else if (elem.next().length && !elem.next().hasClass("minutes_detail_row")) {
				// 1行前の議事録の下に作成
				const prev_id = elem.prev().find(".minutes_manager").attr("id");
				if (this.isJudgeHapyo(minutes_manager)) {
					this.addminutesinfohapyo(new_id, agenda_detail_id, "", prev_id, "0");
				} else {
					this.addminutesinfokaiwa(new_id, agenda_detail_id, "", prev_id, "0");
				}
				
				// 1行前の議事録が存在しない場合、一番下に作成された新規行を一番上に入れ替え
				if(prev_id == undefined) {
					const add_list = list[agenda_detail_id].pop();
					list[agenda_detail_id].splice(0, 0, add_list);
				}
			// 最後の行に移動させた場合、末尾に議事録明細の新規行を追加
			} else if(!elem.next().length) {
				if (this.isJudgeHapyo(minutes_manager)) {
					this.addminutesinfohapyo(new_id, agenda_detail_id, "", "", "0");
				} else {
					this.addminutesinfokaiwa(new_id, agenda_detail_id, "", "", "0");
				}
			}
			
			// 対象のテーマと紐づいていた議事録明細の紐づきを解除
			// 並び替え前の議事録行を取得
			const before_index = list[agenda_detail_id].findLastIndex(({ id }) => id === minutes_id);
			const before_row = list[agenda_detail_id][before_index];
			
			before_row["border"] = false;
			const temp_theme = before_row["theme"];
			before_row["theme"] = null;
			
			// 並び替え後のテーマの次の議事録行を取得
			let next_id = elem.next().find(".minutes_manager").attr("id");
			if(next_id == undefined) {
				next_id = new_id;
			}
			const next_index = list[agenda_detail_id].findLastIndex(({ id }) => id === next_id);
			const next_row = list[agenda_detail_id][next_index];
			next_row["border"] = true;
			next_row["theme"] = temp_theme;
			
			return list;
		},

		escapeHTML(val) {
			if (!isNaN(val)) {
				return val;
			} else if (val == null) {
				return "";
			} else {
				return val
					.replace(/&/g, '&amp;')
					.replace(/</g, '&lt;')
					.replace(/>/g, '&gt;')
					.replace(/"/g, '&quot;')
					.replace(/'/g, "&#x27;");
			}
		},

		createTask() {
			var $target = $(".minutes-active");
			var $targetarea = $target.closest("tr").find(".dummy-tag-area").find('[datatype="task-area"]');
			var $textarea = $target.closest(".minutes_manager_area").find(".minutes_manager");
			var $taskarea = $target.closest("tr").find(".task-area");
			if (!$targetarea.find('[target="' + this.escapeSelectorString($textarea.attr("id")) + '"]').length) {
				var $taskid = "Task" + this.getObjectID();
				var $val = $('<p class="mr-2 text-truncate minutes-task"><i class="innericon mr-1 bi bi-pin-task-fill"></i></p>').attr({ taskorg: "", taskorgname: "", taskperson: "", taskpersonname: "", taskgroup: "", taskid: $taskid, id: $taskid });
				$val.find(".innericon").after($('<span><span class="innericon_span"></span><span class="task_date"></span><span class="task_date_noval">未設定</span></span>'));
				$val.attr("target", $textarea.attr("id"));
				$val.append($("<span class='disp-title-task' nameFlag='true' saveFlag='false'></span>").text($textarea.val()));
				$taskarea.append($val);
				var $task = $target.closest("tr").find(".additional-info-task");
				var $p = $('<i class="bi bi-pin-task-fill"></i>').attr({ "target": $textarea.attr("id"), taskid: $taskid });
				$task.append($p);
				const $append = $('<span></span>').addClass("Tag_Del");
				$task.addClass("tagblock");
				$task.append($append);
				$textarea.closest(".minutes_manager_area").find(".minutes-task").addClass("minutes-active-color");
			}
		},

		addMinuteTableRow(elem) {
			if ($(elem).hasClass("minutes_detail_row")) {
				const $row = $(elem).clone(false);
				$row.css("display", "");
				$row.removeClass("copyrow");
				$(elem).after($row);

				const $textarea = $row.find('textarea.auto-resize');
				$textarea.attr("id", this.getObjectID());

				$textarea.height(26);

				return $row;
			} else {
				const $row = $(elem).closest("tbody").find(".copyrow").clone(false);
				$row.css("display", "");
				$row.removeClass("copyrow");
				$(elem).closest("tr").after($row);

				const $textarea = $row.find('textarea.auto-resize');
				$textarea.attr("id", this.getObjectID());

				$textarea.height(26);

				const $lsize = $(elem).closest("tbody").find(".minutes_manager").attr("lsize");

				$textarea.attr("lsize", $lsize);
				$textarea.css("width", "calc(100% - " + $lsize + "px)");
				$textarea.css("margin-left", $lsize + "px");
				return $row;
			}
		},

		getObjectID() {
			var S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
			var N = 31;
			return "O" + Array.from(crypto.getRandomValues(new Uint8Array(N))).map((n) => S[n % S.length]).join('');
		},

		getAttendList() {
			const $speakerlist = [];
			if ($(".PersonList .PersonBlock").length) {
				$.each($(".PersonList .PersonBlock"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.find(".Person").text()};
					$speakerlist.push($users);
				});
			}
			if ($(".GuestPersonList .GuestPersonBlock").length) {
				$.each($(".GuestPersonList .GuestPersonBlock"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.find(".GuestPerson").text()};
					$speakerlist.push($users);
				});
			}
				
			if ($("#attend_other .Person").length) {
				$.each($("#attend_other .Person"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.text()};
					$speakerlist.push($users);
				});
				$.each($("#attend_other_guest .GuestPerson"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.text()};
					$speakerlist.push($users);
				});
			}
			return $speakerlist;
		},

		changeTextContent(elem) {
			const $contents = $(elem).find(".minutes_manager").val();
			if ($(elem).closest("tr").find(".minute_action_list .minutes-decision").hasClass("minutes-active-color")) {
				$(elem).closest("tr").find(".dummy-tag-area .decision-area .disp-title").text($contents);
				this.refreshMinutesContents($(elem), "decision");
			}
			if ($(elem).closest("tr").find(".minute_action_list .minutes-important").hasClass("minutes-active-color")) {
				$(elem).closest("tr").find(".dummy-tag-area .important-area .disp-title").text($contents);
				this.refreshMinutesContents($(elem), "important");
			}
			if ($(elem).closest("tr").find(".minute_action_list .minutes-task").hasClass("minutes-active-color")) {
				if (!this.parseStrToBoolean($(elem).closest("tr").find(".dummy-tag-area .task-area .disp-title-task").attr("saveflag"))) {
					$(elem).closest("tr").find(".dummy-tag-area .task-area .disp-title-task").text($contents);
				}
				this.refreshMinutesContents($(elem), "task");
			}
		},

		refreshMinutesContents(elem, target) {
			const $target_id = $(elem).find(".minutes_manager").attr("id");
			const $contents = $(elem).find(".minutes_manager").val();
			let $refresh_target = "";
			if (target == "decision") {
				$refresh_target = $(".agenda_side_detail").find("#nav-decision").find("[target=" + $target_id + "]");
			} else if (target == "important") {
				$refresh_target = $(".agenda_side_detail").find("#nav-important").find("[target=" + $target_id + "]");
			} else {
				$refresh_target = $(".agenda_side_detail").find("#nav-task").find("[target=" + $target_id + "]");
			}
			if (target == "task") {
				const $refresh_contents_area = $refresh_target.find(".disp-title-task");
				if (!this.parseStrToBoolean($refresh_contents_area.attr("saveflag"))) {
					$refresh_contents_area.text($contents);
				}
			} else {
				const $refresh_contents_area = $refresh_target.find(".disp-title");
				$refresh_contents_area.text($contents);
			}
		},

		emitCreateRightTag() {
			this.$emit('createrighttag-emit');
		},

		emitCreateRightTask() {
			this.$emit('createrighttask-emit');
		},

		setSortable(elem) {

			var _self = this;

			$(elem).find(".collapse tbody").sortable({
				handle: '.handle',
				items: " > tr ",
				cursor: 'move',
				activate: function (e, obj) {
					var $minutes_manager_area = obj.item;
					var baselsize = $minutes_manager_area.find(".minutes_manager").attr("lsize");
					var $nextall = $minutes_manager_area.nextAll().not(".ui-sortable-placeholder");

					$.each($nextall, function (i, elem) {
						var targetlsize = $(elem).find(".minutes_manager").attr("lsize");
						if (Number(baselsize) < Number(targetlsize)) {
							$(elem).attr("sortable-child-area", "");
						} else {
							return false;
						}
					});
				},
				stop: function (e, obj) {
					// 議事録明細の並び順を同時編集機能に反映
					_self.doMergeMinutesSort(obj.item);
					// return false;
				},
				change: function (e, obj) {
					var $minutes_manager_area = obj.item;
					var $placeholder = obj.placeholder;

					$placeholder.after($minutes_manager_area);
					$minutes_manager_area.after($(".minutes_manager_area[sortable-child-area]"));
				},
				placeholder: 'ui-state-highlight-placeholder',
				start: function (event, ui) {
					ui.placeholder.height(ui.helper.outerHeight());
				},
				update: function (event, ui) {
				},
				helper: this.fixPlaceHolderWidth
			})
		},

		moveMinuteRows(agenda_row) {
			const $agendarow = $(agenda_row);

			if ($agendarow.length) {
				var id = $agendarow.find("span.additional_target").attr("data-target");
				var $minuterow = $agendarow.closest("tbody").find(id).closest("tr");
				$agendarow.after($minuterow);
			}
		},

		resetNo($target) {
			$.each($target, function (i, detail) {
				const $tr_agenda = $(detail);
				if ($tr_agenda.is("[dummy-row]")) {
					return;
				}
				const $prev_tr = $tr_agenda.closest("tr").prev().prev();
				if ($prev_tr.is("[dummy-row]")) {
					$tr_agenda.find(".td-num").text("1");
					$tr_agenda.find(".td-contents").attr("lsize", "0");
					$tr_agenda.find(".bi-caret-left-fill").css("visibility", "hidden");
					$tr_agenda.find(".bi-caret-right-fill").css("visibility", "hidden");
				} else {
					if ($tr_agenda.find(".td-contents").attr("lsize") == "25") {
						$tr_agenda.find(".bi-caret-right-fill").css("visibility", "hidden");
						$tr_agenda.find(".bi-caret-left-fill").css("visibility", "");
						if ($prev_tr.find(".td-contents").attr("lsize") == "25") {
							const $prev_num = $prev_tr.find(".td-num").text();
							const $prev_num_before = $prev_num.substr(0, $prev_num.indexOf('-'));
							let $prev_num_after = $prev_num.substr($prev_num.indexOf('-') + 1);
							$prev_num_after = this.Number($prev_num_after) + 1;
							const $new_num = $prev_num_before + "-" + $prev_num_after;
							$tr_agenda.find(".td-num").text($new_num);
						} else {
							const $prev_num = $prev_tr.find(".td-num").text();
							const $new_num = $prev_num + "-1";
							$tr_agenda.find(".td-num").text($new_num);
						}
					} else {
						$tr_agenda.find(".bi-caret-right-fill").css("visibility", "");
						$tr_agenda.find(".bi-caret-left-fill").css("visibility", "hidden");
						if ($prev_tr.find(".td-contents").attr("lsize") == "25") {
							const $prev_num = $prev_tr.find(".td-num").text();
							let $prev_num_before = $prev_num.substr(0, $prev_num.indexOf('-'));
							$prev_num_before = this.Number($prev_num_before) + 1;
							const $new_num = $prev_num_before;
							$tr_agenda.find(".td-num").text($new_num);
						} else {
							const $prev_num = $prev_tr.find(".td-num").text();
							const $new_num = this.Number($prev_num) + 1;
							$tr_agenda.find(".td-num").text($new_num);
						}
					}
				}
			});
			if ($("#edit_mode").val() == 'minutes_edit') {
				$(".td-contents .bi-caret-right-fill").css("visibility", "hidden");
				$(".td-contents .bi-caret-left-fill").css("visibility", "hidden");
			}
		},

		calcAgendaTime(startTime, $target) {
			var now = new Date();
			var minutetimeTo = new Date(now.getFullYear() + "/" + (now.getMonth() + 1) + "/" + now.getDate() + " " + startTime);
			var minutetimeToSum = new Date(now.getFullYear() + "/" + (now.getMonth() + 1) + "/" + now.getDate() + " " + startTime);

			$.each($target.not("[dummy-row]"), function (i, detail) {
				const $tr_agenda = $(detail);
				if (minutetimeTo.toString() === "Invalid Date") {
					$tr_agenda.find(".td-time").text("");
					return;
				}
				var list = $(".agenda_row td .agendatime");
				if (list.length) {
					var prtime = $tr_agenda.find(".pretime").val();
					var qatime = $tr_agenda.find(".qatime").val();
				} else {
					var prtime = $tr_agenda.find(".td-min").text();
					var qatime = $tr_agenda.find(".td-qa").text();
				}
				var timeFrom = new Date(minutetimeTo);
				minutetimeTo.setMinutes(minutetimeTo.getMinutes() + Number(prtime));
				minutetimeTo.setMinutes(minutetimeTo.getMinutes() + Number(qatime));

				$tr_agenda.find(".td-time").text(formatDateAtMinute(timeFrom) + " - " + formatDateAtMinute(minutetimeTo));
			});
			this.resetNo($("#agenda_table tbody tr.agenda_row"));
		},

		fixPlaceHolderWidth(event, ui) {
			ui.children().each(function () {
				$(this).width($(this).width());
			});
			return ui;
		},

	},

	mounted() {

		const _self = this;


		$(document).on("mousedown", '.person_tag_history_list li.person_list', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			var $taskarea = $(this).closest("tr").find(".table-speaker-area .minutes_speaker_block");
			var $speakerid = $(this).attr("userid");
			var $speakername = $(this).attr("username");
			_self.$refs["SpeakerModal"].appendSpeaker($speakerid, $speakername);
			_self.$nextTick(() => {
				$(this).closest(".minutes_manager_area").find(".minutes_manager").focus();
				return false;
			});

		});

		$(document).on("mousedown", '.person_tag_history_list li.tag_list', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			var $taskarearight = $(this).closest("tr").find(".additional-info-tag").find("i");
			var $text = $(this).attr("tagname");
			var isAdd = true;
			for (var i=0; i < $taskarearight.length; i++) {
				var temp = $taskarearight.eq(i).attr("title");
				if (temp == $text) {
					isAdd = false;
				}
			}

			if (isAdd) {
				_self.$refs["TagModal"].appendTags(0, $text);
			}
			$(this).closest(".minutes_manager_area").find(".minutes_manager").focus();

			return false;
		});

		$(document).on("mousedown", '.minute_action_list li.minutes-decision', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			_self.doClickUsually(e.currentTarget);
			return false;
		});

		$(document).on("mousedown", '.minute_action_list li.minutes-important', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			_self.doClickUsually(e.currentTarget);
			return false;
		});

		$(document).on("mousedown", '.minute_action_list li.minutes-task', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}

			if (!$(this).hasClass("minutes-active-color")) {

				var $textarea = $(this).closest("tr").find(".minutes_manager");
				var taskId = "Task" + _self.getObjectID();
				var minutesId = $textarea.attr("id");
				var agenda_detail_id = $textarea.attr("agenda_detail_id");
				var target = $textarea.attr("judge_minutes");

				_self.doMergeMinutesTask(target, agenda_detail_id, minutesId, taskId, [], [], [], [], [], [], [], true, false, true, null, null);
			}

			return false;
		});

		$(document).on("mouseenter", '.tagblock .Tag_Del', function () {
			$(this).removeClass("Tag_Del").addClass("Tag_Del_focus");
		});

		$(document).on("mouseleave", '.tagblock .Tag_Del_focus', function () {
			$(this).removeClass("Tag_Del_focus").addClass("Tag_Del");
		});

		$(document).on("click", '.Tag_Del_focus', function (e) {
			_self.eventStop(e);
			var $tagblock = $(this).closest(".tagblock");
			var $textarea = $(this).closest("tr").find(".minutes_manager");
			var agenda_detail_id = $textarea.attr("agenda_detail_id");
			var minutes_id = $textarea.attr("id");
			var target = "";
			if (_self.isJudgeHapyo($textarea)) {
				target = 'hapyo';
			} else {
				target = 'kaiwa';
			}

			if ($(this).closest(".additional-info-tag").length) {
				if ($tagblock.length) {
					const tagId = $tagblock.find("i").attr("id");

					_self.doMergeMinutesTag(target, agenda_detail_id, minutes_id, tagId, null, true);
					return false;
				}
			} else if ($(this).closest(".additional-info-decision").length || $(this).closest(".additional-info-important").length) {
				const $target_id = $(this).closest(".tagblock").find("i").attr("target");
				const $target_minutes = $("#" + $target_id);
				if ($(this).closest(".additional-info-decision").length) {
					_self.doClickUsually($target_minutes.closest(".minutes_manager_area").find("li.minutes-decision"));
				} else {
					_self.doClickUsually($target_minutes.closest(".minutes_manager_area").find("li.minutes-important"));
				}
			} else if ($(this).closest(".additional-info-task").length) {
				const minutesId = $(this).closest(".tagblock").find("i").attr("target");
				const taskId = $(this).closest(".tagblock").find("i").attr("taskid");
				const agenda_detail_id = $(this).closest("tr").find(".minutes_manager").attr("agenda_detail_id");
				const target = $(this).closest("tr").find(".minutes_manager").attr("judge_minutes");


				const $target_p = $("[taskid=" + taskId + "]");
				if ($(this).closest("tr").find(".disp-title-task").attr("saveflag") == "true") {
					if (!window.confirm("タスクを削除しますか？")) {
						return;
					}
				}
				_self.doMergeMinutesTask(target, agenda_detail_id, minutesId, null, [], [], [], [], [], [], [], false, false, true, null, null);

			} else {
				if ($tagblock.length) {
					$tagblock.remove();
					_self.doMergeMinutesUsually(target, agenda_detail_id, minutes_id, false, "speaker");
					return false;
				}
			}
		});

		$(document).on("mousedown", '.write-icon', function (e) {
			var $minutes_manager_area = $(this).closest(".minutes_manager_area");
			setTimeout(function () {
				$minutes_manager_area.find("textarea").focus();
			}, 50);
		});

		$(document).on("mouseup", '.minute_action_list li.minutes-tag', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			const $activecheck = $(".minutes-canfocus.minutes-active");
			if ($activecheck.length) {
				$(this).focus();
			}
			$("#minutes-tag-modal").modal();
			return false;
		});

		$(document).on("mouseup", '.minute_action_list li.minutes-speaker', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			const $activecheck = $(".minutes-canfocus.minutes-active");
			if ($activecheck.length) {
				$(this).focus();
			}
			$("#minutes-speaker-modal").modal();
			return false;
		});

		$(document).on("mousedown", '.minute_action_list li.minutes-addrow', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}

			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			var $textarea = $(".minutes-active");

			const nextMinutesManagerId = nanoid(32);
			const lsize = $textarea.attr("lsize");
			if (_self.isJudgeHapyo($textarea)) {
				_self.confirm_minutes_manager_hapyo($textarea);
				_self.addminutesinfohapyo(nextMinutesManagerId, $textarea.attr("agenda_detail_id"), "", $textarea.attr("id"), lsize)
			} else {
				_self.confirm_minutes_manager_kaiwa($textarea);
				_self.addminutesinfokaiwa(nextMinutesManagerId, $textarea.attr("agenda_detail_id"), "", $textarea.attr("id"), lsize)
			}
		});

		$(document).on("mousedown", '.minute_action_list li.minutes-border, .additional-info-theme span, .additional-info-theme i', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			var $minutes_manager_area = $(this).closest(".minutes_manager_area");
			$minutes_manager_area.find(".minutes_manager").focus();
			$("#minutes-theme-modal").modal();

			return false;
		});

		$(document).on("mouseup", '.minute_action_list li.minutes-delete', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			_self.deleteMinutesRow($(this));
			return false;
		});

		$(document).on("mousedown", '.minutes_manager_ul_right span:not(".additional-info-speaker")', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			const $textarea = $(this).closest(".minutes_manager_area").find(".minutes_manager");
			if (!$textarea.hasClass("minutes-active")) {
				$textarea.focus();
			}
			return false;
		});

		$(document).on("mousedown", '.minutes-ul .decision-area p', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).attr("target"))).focus();
			return false;
		});

		$(document).on("mousedown", '.minutes-ul .important-area p', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).attr("target"))).focus();
			return false;
		});

		$(document).on("mousedown", '.minutes-ul .task-area p', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).attr("target"))).focus();
			$(this).attr("active-modal-icon", "");
			$("#minutes-task-modal [name='minutes_taskorg']").val($(this).attr("taskorg"));
			$("#minutes-task-modal").modal();
			return false;
		});

		$(document).on("click", '.additional-info-speaker .minutes_speaker_span', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).attr("target"))).focus();
			$("#minutes-speaker-modal").modal();
			return false;
		});

		$(document).on("mousedown", '.table-tag-area .additional-info-task i', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).attr("target"))).focus();
			setTimeout(function(){ 
				$("#minutes-task-modal").modal();
			}, 50);
			
			return false;
		});

		$(document).on("mousedown", '.additional-info-tag i', function (e) {
			if ($(this).hasClass("Tag_Del")) {
				return false;
			}
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).attr("target"))).focus();
			const $targetTag = $(this).closest("i").attr("id");
			$(this).attr("active-modal-icon", "");
			$("#minutes-tag-modal").modal();
			return false;
		});

		$(document).on("click", '.additional-info-tag .tagblock', function (e) {
			if ($(this).hasClass("Tag_Del")) {
				return false;
			}
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).find("i").attr("target"))).focus();
			const $targetTag = $(this).closest("i").attr("id");
			$(this).attr("active-modal-icon", "");
			$("#minutes-tag-modal").modal();
			return false;
		});

		$(document).on("mousedown", '.minutes-ul .tag-area p', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$("#" + _self.escapeSelectorString($(this).attr("target"))).focus();
			$(this).attr("active-modal-icon", "");
			$("#minutes-tag-modal").modal();
			return false;
		});

		$(document).on("click", '.attend-add-btn', function () {
			$("#attendmodal").modal();
		});

		$(document).on("mousedown", '.minutes_manager_ul', function (e) {
			_self.eventStop(e);
			if (!_self.isLeftClick(e)) {
				return false;
			}
			$(this).closest(".minutes_manager_area").find(".minutes_manager").focus();
			return false;
		});

		$(document).on("focusin", '.minute_action_list li', function (e) {
			_self.eventStop(e);
		});

		$(document).on("focusin", '.minutes_manager_area', function (e) {

			$(this).find(".minutes_manager").css('background-color', '#ffc');
			$(this).find(".minute_action_list").css("display", "flex");
			var historylist = [];
			var appendcount = 0;
			var that = $(this);
			var attendlist = _self.getAttendList();
			var $modal = $("#minutes-speaker-modal");
			var $existlist = that.find(".person_tag_history_list .person_list");

			$.each($modal.find('.speaker_history span'), function (i, elem) {
				if (appendcount >= 5) {
					return false;
				}
				var speakeruserobj = attendlist.find((v) => v.USER_ID === _self.escapeSelectorString($(this).attr("userid")));
				var historyobj = historylist.find((v) => v.USER_ID === elem["USER_ID"]);
				if (speakeruserobj != undefined && historyobj == undefined) {
					historylist.push(speakeruserobj);
					var $usericon = $("<i></i>").addClass("bi bi-person-circle2 mr-1");
					$usericon.append($("<span></span>").addClass("innericon_span ml-1").text(speakeruserobj["USER_NAME"]));
					if ($existlist.eq(i).length) {
						$existlist.eq(i).attr({ tabindex: "0", userid: speakeruserobj["USER_ID"], username: speakeruserobj["USER_NAME"] }).find(".innericon_span").text(speakeruserobj["USER_NAME"]);
					} else {
						var $appenddata = $("<li></li>").addClass("list-group-item cursor-pointer minutes-canfocus person_list").attr({ tabindex: "0", userid: speakeruserobj["USER_ID"], username: speakeruserobj["USER_NAME"] });
						$appenddata.append($usericon);
						that.find(".person_history_list").append($appenddata.clone(false));
					}
					appendcount++;
				}
			});

			var historylist = [];
			var appendcount = 0;
			var that = $(this);
			var $modal = $("#minutes-tag-modal");
			var $existlist = that.find(".person_tag_history_list .tag_list");

			$.each($modal.find('.minutes_tagname_history span'), function (i, elem) {
				if (appendcount >= 3) {
					return false;
				}
				var $tagval = $(elem).text();
				var historyobj = historylist.find((v) => v.value === _self.escapeSelectorString($(elem).text()));
				if (historyobj == undefined) {
					historylist.push({ value: $(elem).text() });
					var $usericon = $("<i></i>").addClass("bi bi-tags-fill2 mr-1");
					$usericon.append($("<span></span>").addClass("innericon_span ml-1").text($(elem).text()));
					if ($existlist.eq(i).length) {
						$existlist.eq(i).attr({ tabindex: "0", tagname: $(elem).text() }).find(".innericon_span").text($(elem).text());
					} else {
						var $appenddata = $("<li></li>").addClass("list-group-item cursor-pointer minutes-canfocus tag_list").attr({ tabindex: "0", tagname: $(elem).text() });
						$appenddata.append($usericon);
						that.find(".tag_history_list").append($appenddata.clone(false));
					}
					appendcount++;
				}
			});

			$(this).find(".person_tag_history_list").css("display", "flex");
			$(this).find(".minutes_manager").addClass("minutes-active");
			$(this).find(".minutes_manager").css('background-color', '#ffc');
			const $lsize = $(this).find(".minutes_manager").attr("lsize");
			$(this).find(".minutes_manager").css({ "width": "calc(100% - " + $lsize + "px)" });
		});

		$(document).on("focusout", '.minutes_manager_area', function (e) {

			const $related = $(e.relatedTarget);
			if ($related.hasClass("modal")) {
			} else if ($related.hasClass("minutes-canfocus")) {
				$(this).find(".minutes-active").removeClass("minutes-active");
				$related.addClass("minutes-active");
			} else {
				$(this).find(".minutes_manager").css('background-color', '');
				$(this).find(".minute_action_list").css("display", "none");
				$(this).find(".person_tag_history_list").css("display", "none");
				$(this).find(".minutes-active").removeClass("minutes-active");
			}
		});

		// 組織名のみを表示
		$(document).on('change', $(".dept_code_detail").next().find(".select2-selection__rendered"), function () {
			let selectDept = $(".dept_code_detail").next().find(".select2-selection__rendered");
			$.each(selectDept, function (i) {
				// プレースホルダは対象外
				if (selectDept[i].firstElementChild == null) {
					let deptName = selectDept[i].innerText;
					deptName = deptName.replace(/^\[[0-9a-zA-Z]*\]\s/, "");
					selectDept[i].innerHTML = deptName;
				}
			})
		});

		// ユーザー名のみを表示
		$(document).on('change', $(".user-select").next().find(".select2-selection__rendered"), function () {
			let selectUser = $(".user-select").next().find(".select2-selection__rendered");
			$.each(selectUser, function (i) {
				// プレースホルダは対象外
				if (selectUser[i].firstElementChild == null) {
					let userName = selectUser[i].innerText;
					userName = userName.replace(/^\[[0-9a-zA-Z]*\]\s/, "");
					selectUser[i].innerHTML = userName;
				}
			})
		});


	}
}
</script>
<style>
.modal-backdrop {
	background-color: transparent !important;
}
</style>